import React, { useRef, useState } from "react";
import { Button, Grid, TextField, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { validateEmail } from "../../../utils";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";

const UserDetails = () => {
  const [data, setData] = useState<any>(null);
  const [email, setEmail] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "registerationDate",
      headerName: "Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "userId",
      headerName: "UserId",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "email",
      headerName: "Email",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "firstName",
      headerName: "FirstName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "lastName",
      headerName: "LastName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "fullName",
      headerName: "FullName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "phone_Number",
      headerName: "PhoneNumber",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "isEmailConfirmed",
      headerName: "EmailConfirmed",
      filter: true,
      resizable: true,
      sortable: true,
      cellDataType: "text",
    },
    {
      field: "userStatus",
      headerName: "User Status",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];
  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (
      firstName.trim() !== "" ||
      email.trim() !== "" ||
      lastName.trim() !== ""
    ) {
      if (email.trim() !== "" && !validateEmail(email.trim())) {
        toast.error("Please Enter Valid Email Address");
        return false;
      }
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please Enter Valid  Input.");
    }
  };

  const requestBundles = async () => {
    await sendCreditAxios
      .post(`/CRMUser/GetAllUserDetailsAsync`, {
        email: email.trim(),
        firstName: firstName,
        lastName: lastName,
      })
      .then((res: any) => {
        setAction(false);
        const apiresponse = res.data?.payload;
        if (apiresponse?.length > 0) {
          setData(apiresponse);
        } else {
          toast.error("Record not found.");
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">User Details</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={3.5}>
              <TextField
                className="formControl"
                label="FirstName"
                variant="outlined"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>
            <Grid item xs={3.5}>
              <TextField
                className="formControl"
                label="LastName"
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>
            <Grid item xs={3.5}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 40 }}
              />
            </Grid>
            <Grid item xs={1.5}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            enableCellTextSelection={true}
            columnDefs={columnDefs}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default UserDetails;
